import React from 'react';

import ModalWindow from '../../modal-window';

import './modal-portal.less';

const ModalPortal = props =>
  (
    <div className="waModalPortal">
      <ModalWindow {...props} />
    </div>
  );

ModalPortal.Header = ModalWindow.Header;
ModalPortal.Content = ModalWindow.Content;
ModalPortal.Footer = ModalWindow.Footer;

export default ModalPortal;